import { render, staticRenderFns } from "./TabsTablesComponent.vue?vue&type=template&id=72d07a97&"
import script from "./TabsTablesComponent.vue?vue&type=script&lang=js&"
export * from "./TabsTablesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports